import React from 'react';
import { Badge, Button } from 'chic-ui';
import { Row } from 'react-bootstrap';

const ButBadges = () => {
  return (
    <div>
      <h4 className="mt-5">Buttons and Badges</h4>
      <p>
      Badges can be used inside <i>Buttons</i> as well!
      </p>
      <div className="btn-group btns mt-3">
      <Button type='secondary' size="large">
      Total Clicks
      <Badge type='success' rounded>199</Badge>
    </Button>
    </div>

      <Row className="mt-3" fluid>
        <code>
          {'import { Badge, Button } from "chic-ui";'}
          <br />
          {'<Button type="secondary" size="large">'}
          <br />
          {'Total Clicks <Badge type="success" rounded>199</Badge>'}
          <br />
          {'</Button>'}
        </code>
      </Row>
    </div>
  );
};

export default ButBadges;
